<div *ngIf="patient" id="main-wrapper">
  <div (click)="goToHome()" id="logo-wrapper">
    <msd-logo id="large-logo" [small]="false"></msd-logo>
  </div>
  <div id="header-wrapper">
    <div class="information-section">
      <div id="identity-wrapper">
        <div id="avatar-wrapper">
          <msd-avatar [src]="patient!.avatarUrl" [text]="patient!.initials"></msd-avatar>
        </div>
        <div id="name-wrapper">
          <h2 id="full-name-text">{{ patient!.fullName }}</h2>
          <label *ngIf="patient!.createdAt" id="sign-up-date-text">Inscrit le {{ formattedCreatedAtDate }}</label>
        </div>
      </div>
    </div>
  </div>

  <msd-next-appointment-cell [appointment]="appointment"
                             class="desktop">
  </msd-next-appointment-cell>

  <div id="consultation-wrapper" class="information-section">
    <label id="reason-title-text">Motif de consultation</label>
    <p id="reason-value-text">{{ patient!.consultationReason ?? 'Aucune' }}</p>
  </div>

  <div *ngIf="patient.isSharedSeries" id="biometric-wrapper">
    <msd-personal-information-rounded-cell [label]="'Taille en cm'"
                                           [value]="size?.toString()"
                                           [withPlus]="false">
    </msd-personal-information-rounded-cell>
    <msd-personal-information-rounded-cell [label]="'Poids en KG'"
                                           [value]="weight?.toString()"
                                           [withPlus]="false">
    </msd-personal-information-rounded-cell>
    <msd-personal-information-rounded-cell [isLoading]="isWeightLoading"
                                           [label]="'IMC'"
                                           [value]="imc(weight, size)">
    </msd-personal-information-rounded-cell>
  </div>
</div>





<div id="footer-wrapper">
  <ul id="navigation-items-wrapper" class="nav nav-pills mb-auto">
    <msd-sidebar-cell (click)="signOut.emit()" [name]="'Déconnexion'" [icon]="'iconly-Logout'">
    </msd-sidebar-cell>
  </ul>
</div>
